var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{attrs:{"id":"testtesttest"}},[_vm._v("Download - "+_vm._s(_vm.$route.params.file_id))])
}
var staticRenderFns = []

export { render, staticRenderFns }